module.exports = __webpack_public_path__ + "static/mapa-meta-aprendizado-f7af450a27717d1330b47af4a2ebd0e6.jpg";